import { render } from "./Albums-page.vue?vue&type=template&id=75ac1fd2&scoped=true"
import script from "./Albums-page.vue?vue&type=script&lang=js"
export * from "./Albums-page.vue?vue&type=script&lang=js"

import "./Albums-page.vue?vue&type=style&index=0&id=75ac1fd2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ac1fd2"]])

export default __exports__